type SentryModule = typeof import('@sentry/browser');

/**
 * Runs `use` with the Sentry SDK once its chunk has loaded. Sentry is only a reporter: when
 * the chunk cannot load (a deploy replaced it under an open tab, a blocker stopped it) there is
 * nothing to report to, so the failure is dropped rather than left as an unhandled rejection.
 */
export function withSentry(use: (sentry: SentryModule) => void): void {
    import('@sentry/browser').then(use, () => {});
}
